import SloganWhite from "src/assets/cards/SloganWhite.png";
import SloganRed from "src/assets/cards/SloganRed.png";
import SloganBlack from "src/assets/cards/SloganBlack.png";

const MerciSlogan = ({ background }: { background: number }) => {
  if (background === 0 || background === 3) {
    return <img alt="Herzliche Intelligenz" src={SloganWhite} />;
  }
  if (background === 1) {
    return <img alt="Herzliche Intelligenz" src={SloganRed} />;
  }
  if (background === 2) {
    return <img alt="Herzliche Intelligenz" src={SloganBlack} />;
  }
  return <></>;
};

export default MerciSlogan;
